<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Tạo mới quy chế, quy định, quy trình
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="200px"
      >
        <!--  Trường cũ (Tên chỉ đạo) -->
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tên QC/QĐ/QT" prop="meeting">
              <el-input
                type="textarea"
                v-model="form.meeting"
                placeholder="Tên Quy Chế/ Quy Định/ Quy Trình"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="5000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <hc-quychequydinh-doc-relations
              ref="hcCommandsDocRelations"
              :objectType="HC_DOC_RELATION.OBJECT_TYPE.HC_QUYCHEQUYDINH_COMMON"
              :deptId="parentDeptId"
              @docSelected="relatedDocSelected"
            ></hc-quychequydinh-doc-relations>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ngày chỉ đạo" prop="commandsDate">
              <el-date-picker
                v-model="form.commandsDate"
                type="date"
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                placeholder="dd/mm/yyyy"
                format="dd/MM/yyyy"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Trường cũ Thời hạn hoàn thành -->
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Hạn xử lý" prop="deadline">
              <el-date-picker
                v-model="form.deadline"
                type="date"
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                placeholder="dd/mm/yyyy"
                format="dd/MM/yyyy"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Lãnh đạo phụ trách" prop="performId">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.performId"
                placeholder="Lãnh đạo phụ trách"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in listDirectives"
                  :key="item.id"
                  :label="`${item.fullName} - ${item.positionName}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Đơn vị chủ trì" prop="chuTriDeptIds">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.chuTriDeptIds"
                placeholder="Đơn vị chủ trì"
                size="medium"
                filterable
                clearable
                multiple
                @change="chuTriDeptIdsChanged"
              >
                <el-option
                  v-for="item in listDept"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!--Trường cũ (Ý kiến chỉ đạo của LĐ)-->
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                v-model="form.note"
                type="textarea"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                show-word-limit
                maxlength="5000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import CustomDialog from "../../common/custom-dialog";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import Vue from "vue";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import departmentService from "../../../services/departmentService";
import h from "../../../services/h";
import constants from "../../../constants";
import hcQuyCheQuyDinhCommonService from "../../../services/quychequydinh/hcQuyCheQuyDinhCommonService";
import HcQuychequydinhDocRelations from "./hc-quychequydinh-doc-relations";

export default {
  name: "hc-quychequydinh-create-dialog-2",
  props: ["isOpen", "id", "flowId", "parentDeptId", "flowCode"],
  mixins: [handleRequestErrorMixin],
  components: { HcQuychequydinhDocRelations, CustomDialog },

  data() {
    return {
      sectors: [],
      listDirectives: [],
      listDept: [],
      form: {
        meeting: null,
        sector: null,
        commandsDate: null,
        conclusion: null,
        directiveId: null,
        performId: null,
        chuTriDeptIds: null,
        phoiHopDeptIds: null,
        deadline: null,
        note: null
      },
      rules: {},
      HC_DOC_RELATION: constants.HC_DOC_RELATION
    };
  },

  created() {
    this.initSelectOptions();
    this.initValidationRules();
    this.loadDirectiveActors();
    this.loadDepartments();
  },

  methods: {
    relatedDocSelected(event) {
      let relatedDoc = event.relatedDoc;
      console.log()
      if (
        relatedDoc.referenceObjectType ===
        constants.HC_DOC_RELATION.REFERENCE_OBJECT_TYPE.VB_OUTGOING_DOC
      ) {
        this.form.commandsDate = relatedDoc.docDate;
        // Auto nhập nội dung lên trường "Cuộc họp" thay vì lên trường "Nội dung kết luận" như hiện tại
        // this.form.conclusion = relatedDoc.quote;
        this.form.meeting = relatedDoc.quote;
      }
    },

    chuTriDeptIdsChanged() {
      this.$refs.form.validateField("chuTriDeptIds");
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };

      let chuTriDeptIdsConstrains = {
        validator: (rule, value, callback) => {
          if (!value || !value.length) {
            return callback(new Error("Trường dữ liệu bắt buộc"));
          } else {
            callback();
          }
        },
        trigger: "blur"
      };

      Vue.set(this.rules, "meeting", [defaultRequiredConstrains]);
      Vue.set(this.rules, "sector", [defaultRequiredConstrains]);
      Vue.set(this.rules, "commandsDate", [defaultRequiredConstrains]);
      Vue.set(this.rules, "deadline", [defaultRequiredConstrains]);
      Vue.set(this.rules, "conclusion", [defaultRequiredConstrains]);
      Vue.set(this.rules, "directiveId", [defaultRequiredConstrains]);
      // Vue.set(this.rules, "performId", [defaultRequiredConstrains]);
      Vue.set(this.rules, "chuTriDeptIds", [
        defaultRequiredConstrains,
        chuTriDeptIdsConstrains
      ]);
      // Vue.set(this.rules, "deadline", [defaultRequiredConstrains]);
    },

    initSelectOptions() {
      return hanhChinhUtils
        .buildHcCommandSectorOptions()
        .then(sectors => (this.sectors = sectors));
    },

    convertToSubmitForm() {
      let deptForms = [];
      h.each(this.form.chuTriDeptIds, deptId =>
        deptForms.push({
          deptId: deptId,
          processType: constants.HC_QUYCHEQUYDINH.PROCESS_TYPE.CHU_TRI
        })
      );
      h.each(this.form.phoiHopDeptIds, deptId =>
        deptForms.push({
          deptId: deptId,
          processType: constants.HC_QUYCHEQUYDINH.PROCESS_TYPE.PHOI_HOP
        })
      );

      let docRelationForms = this.$refs.hcCommandsDocRelations.getSubmitForms();

      let submitForm = {
        flowId: this.flowId,
        flowCode: this.flowCode,
        meeting: this.form.meeting,
        // sector: this.form.sector,
        commandsDate: this.form.commandsDate
          ? this.form.commandsDate.getTime()
          : null,
        conclusion: this.form.conclusion,
        // directiveId: this.form.directiveId,
        performId: this.form.performId,
        // deptId: this.form.deptId,
        deptForms: deptForms,
        deadline: this.form.deadline ? this.form.deadline.getTime() : null,
        note: this.form.note,
        docRelationForms: docRelationForms
      };
      return submitForm;
    },

    // validateDonViChuTri() {
    //   return new Promise(resolve => {
    //     let chuTriDeptIds = this.form.chuTriDeptIds;
    //     if (!chuTriDeptIds || !chuTriDeptIds.length) {
    //       this.$message({
    //         message: "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
    //         type: "error"
    //       });
    //     } else {
    //       resolve();
    //     }
    //   });
    // },

    validateCommandsDateAndDeadline() {
      return new Promise(resolve => {
        if (
          this.form.commandsDate &&
          this.form.deadline &&
          this.form.commandsDate.getTime() > this.form.deadline.getTime()
        ) {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcQuyTrinh.invalidCommandsDateAndDeadline"
            }),
            type: "error"
          });
        } else {
          resolve();
        }
      });
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message({
              message: "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
              type: "error"
            });
          } else {
            resolve();
          }
        });
      });
    },

    validateDonViThucHienIds() {
      return new Promise(resolve => {
        let isOk = !h.exists(this.form.chuTriDeptIds, deptId =>
          h.exists(this.form.phoiHopDeptIds, deptId2 => deptId === deptId2)
        );
        if (!isOk) {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcQuyTrinh.duplicateRoleDonViThuHien"
            }),
            type: "error"
          });
        } else {
          resolve();
        }
      });
    },

    // validateActorId() {
    //   return new Promise(resolve => {
    //     if (this.form.directiveId === this.form.performId) {
    //       this.$message({
    //         message: errorMessageFilter({
    //           errorCode: "hcQuyTrinh.duplicateChiDaoActor"
    //         }),
    //         type: "error"
    //       });
    //     } else {
    //       resolve();
    //     }
    //   });
    // },

    save() {
      return (
        this.validateForm()
          .then(() => this.validateCommandsDateAndDeadline())
          .then(() => this.validateDonViThucHienIds())
          // .then(() => this.validateActorId())
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            return hcQuyCheQuyDinhCommonService
              .create(submitForm)
              .then(response => response.data);
          })
          .then(hcCaseCommands => {
            this.$message({
              message: errorMessageFilter({
                errorCode: "hcQuyTrinh.insertSuccess"
              }),
              type: "success"
            });
            this.$emit("insertSuccess", { result: hcCaseCommands });
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          })
      );
    },

    loadDirectiveActors() {
      return userDeptRoleViewService
        .findAllForHcQuyTrinh(this.parentDeptId)
        .then(response => (this.listDirectives = response.data));
    },

    loadDepartments() {
      return departmentService
        .findAllForHcQuyTrinh(this.parentDeptId)
        .then(response => (this.listDept = response.data));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/quychequydinh/hc-quychequydinh-create-dialog-2.vue